<div class="exception-body accessdenied">
    <div class="exception-panel">
        <div class="exception-image">
            <img src="assets/layout/images/exception/icon-access.png">
        </div>

        <div class="exception-detail">
            <h1>ACCESO DENEGADO</h1>
            <p>No tiene acceso a la funcionalidad.</p>
            <p-button label="IR AL INICIO" [routerLink]="['/']"></p-button>
        </div>
    </div>
</div>
